import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Card } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    { key: 'consultation', icon: '👨‍⚕️', color: 'bg-blue-50' },
    { key: 'endoscopy', icon: '🔬', color: 'bg-purple-50' },
    { key: 'waxRemoval', icon: '👂', color: 'bg-green-50' },
    { key: 'microscope', icon: '🔍', color: 'bg-yellow-50' },
    { key: 'foreignBody', icon: '🏥', color: 'bg-red-50' },
    { key: 'allergyTesting', icon: '🧪', color: 'bg-indigo-50' },
    { key: 'vertigo', icon: '⚖️', color: 'bg-pink-50' }
  ];

  return (
    <div className="min-h-screen py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl lg:text-5xl font-bold text-primary mb-6" data-testid="services-page-title">
            {t('services.title')}
          </h1>
          <p className="text-base lg:text-lg text-muted-foreground max-w-3xl mx-auto" data-testid="services-page-subtitle">
            {t('services.subtitle')}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <motion.div
              key={service.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="p-8 card-hover h-full" data-testid={`service-detail-card-${service.key}`}>
                <div className={`w-16 h-16 rounded-2xl ${service.color} flex items-center justify-center mb-6`}>
                  <span className="text-4xl">{service.icon}</span>
                </div>
                <h3 className="text-xl font-bold text-foreground mb-4">
                  {t(`services.${service.key}.title`)}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {t(`services.${service.key}.description`)}
                </p>
              </Card>
            </motion.div>
          ))}
        </div>

        <div className="text-center bg-secondary/50 rounded-3xl p-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-primary mb-4" data-testid="services-cta-title">
            Ready to Get Started?
          </h2>
          <p className="text-muted-foreground mb-8 max-w-2xl mx-auto">
            Book your appointment today for a comprehensive ENT consultation
          </p>
          <Link to="/appointment">
            <Button size="lg" className="btn-primary rounded-full px-8" data-testid="services-cta-button">
              Book an Appointment
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
